import type React from 'react';

import type { SxProps, Theme } from '@mui/material/styles';

import { Stack } from 'ui/stack';
import { mergeSx } from 'ui/merge-sx';

const CARD_SX: SxProps<Theme> = {
  flex: '1 1 0%',
  gap: 1,
  borderRadius: '0.375rem',
  bgcolor: 'tokens.navy.50',
  px: 2,
  pb: 2,
  pt: 1.5,
};

interface MarkFeatureCardProps {
  icon: React.ElementType;
  title: string;
  description: string;
  sx?: SxProps<Theme>;
}

const MarkFeatureCard = ({
  icon,
  title,
  description,
  sx,
}: MarkFeatureCardProps): React.JSX.Element => {
  const Icon = icon;

  return (
    <Stack sx={mergeSx(CARD_SX, sx)}>
      <Icon className="size-5 text-navy-500" />
      <Stack sx={{ gap: 0.25 }}>
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        <p className="text-sm leading-5 text-gray-700">{description}</p>
      </Stack>
    </Stack>
  );
};

export default MarkFeatureCard;
